import { createAction } from '@reduxjs/toolkit';

export const LOGOUT_ACTION_TYPE = 'saga/logout';
export const logoutAction = createAction(LOGOUT_ACTION_TYPE);
